import React from "react";

/* img imports */
import tentSingle from "../assets/images/tents/main-tent-single.png";
import arrow from "../assets/images/tents/tent-forward-arrow.png";

/* comp imports */
import GamesTent from "./GamesTent";
import VideosTent from "./VideosTent";
import RecipesTent from "./RecipesTent";

const InsideTents = ({ handleRedirect }) => {
  return (
    <>
      <GamesTent
        handleRedirect={handleRedirect}
        tentSingle={tentSingle}
        arrow={arrow}
      />
      <RecipesTent
        handleRedirect={handleRedirect}
        tentSingle={tentSingle}
        arrow={arrow}
      />
      <VideosTent
        handleRedirect={handleRedirect}
        tentSingle={tentSingle}
        arrow={arrow}
      />
    </>
  );
};

export default InsideTents;
